import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PaymentVerify } from "../../api/api";
import SuccessPayment from "./SuccessPayment";
import FailedPayment from "./FailedPayment";


const Payment = () => {

     const [content, setContent] = useState([])
     const [loading, setLoading] = useState(false)
     const params = useParams()

     useEffect(() => {
          const peyment_verify = async () => {
               try {
                    setLoading(true)
                    const res = await axios.get(PaymentVerify(params.paymentId))
                    console.log(res.data);
                    setContent(res.data);
               } catch (error) {
                    console.log(error);
               } finally { setLoading(false) }
          }
          peyment_verify()
     }, [])


     if (content.getWayStatus?.id === 1) {
          return <SuccessPayment title={content.description} code={content.transactionId} />
     } else {
          return loading ? 'loading...' : <FailedPayment title={content.description} code={content.transactionId} />
     }

}

export default Payment;